import React from 'react';
import Moment from 'react-moment';
import 'moment-timezone';
import './summary.styles.scss';
import Chart from "react-google-charts";
import Loader from 'react-loader-spinner';
import { formatNumber } from '../../utils/helper';

class Summary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      summarydata: null
    }
  }

  intervalID = null;

  async loadData() {
    console.log('Summary param', this.props.param);
    try {
      let url = 'https://corona.lmao.ninja/v2/all';
      let url1 = 'https://corona.lmao.ninja/v2/all?yesterday=true';
      // url = 'https://us-central1-covid-data-baff6.cloudfunctions.net/fetchData';

      if (this.props.param) {
        url = `https://corona.lmao.ninja/v2/countries/${this.props.param}`;
        url1 = `https://corona.lmao.ninja/v2/countries/${this.props.param}?yesterday=true`;
      }

      var data = await Promise.all([
        fetch(url).then((response) => response.json()),// parse each response as json
        fetch(url1).then((response) => response.json())
      ]);

      // console.log(data1);

      // const res = await fetch(url);
      // let data = await res.json();

      // const { currentData, prevData } = data;
      // console.log(currentData);
      // console.log(prevData);


      this.setState({
        summarydata: data[0],
        prevsummarydata: data[1],
        dataLoaded: true,
        timestamp: data.updated
      });




    } catch (e) {
      console.log(e);
    }
  }

  componentDidMount() {
    this.loadData();
  }

  render() {
    const { param } = this.props;
    let app = (
      <div className="loader">
        <Loader
          type="Circles"
          color="#00BFFF"
          height={100}
          width={100}
        />
      </div>
    );
    if (this.state.dataLoaded) {
      const { summarydata: { cases, todayCases, deaths, todayDeaths,
        recovered, active, critical, casesPerOneMillion, deathsPerOneMillion,
        tests, testsPerOneMillion, affectedCountries, country } } = this.state;

      const { prevsummarydata: { recovered: prevRecovered, active: prevActive } } = this.state;

      //const todayActive = active - 
      app = (
        <React.Fragment>
          <h2 className="summary--title">
            {param ? (<React.Fragment><img src={`https://www.countryflags.io/${param}/flat/64.png`} alt="flag"></img> {country}</React.Fragment>) : 'GLOBAL'}
          </h2>
          <div className="summary--innerwrapper">
            <div className="summary--graph">
              <Chart
                className="graph"
                chartType="BarChart"
                width="100%"
                data={[
                  ['Global Cases', 'Cases', { role: 'style' }],
                  ['Cases', (cases), "#3f7fff"],
                  ['Active', (active), "#ffb201"],
                  ['Recovered', recovered, "#4caf50"],
                  ['Fatal', deaths, "#ff0000"]
                ]}
                options={{
                  chartArea: { width: '60%' },
                  legend: { position: "none" },
                  animation: {
                    duration: 2000,
                    easing: 'out',
                    startup: true,
                  },
                  hAxis: {
                    format: 'short'
                  },
                  vAxis: {
                    format: 'short',
                  }
                }}
              />
            </div>
            <div className="summary--stats">
              <div className="summary--section">
                <div className="total--cases">
                  <div>
                    <p>Confirmed Cases</p>
                    <h3>{formatNumber(cases)}
                      <sup className="error">{
                        todayCases > 0 ? ` +${formatNumber(todayCases)}` : ` -${formatNumber(todayCases)}`
                      }</sup>
                    </h3>
                    <p><sub className="error">{casesPerOneMillion} per million</sub><sub> - </sub><sub className="active">{formatNumber(tests)} tested</sub></p>
                  </div>
                </div>
                <div className="total--active">
                  <div>
                    <p>Active Cases</p>
                    <h3>{formatNumber(active)}
                      <sup className="error">{
                        (active - prevActive) > 0 ? ` +${formatNumber(active - prevActive)}` : ` -${formatNumber(prevActive - active)}`
                      }</sup>
                    </h3>
                    <p><sub className="error">{formatNumber(critical)} in critical condition</sub></p>
                  </div>
                </div>
              </div>
              <div className="summary--section">
                <div className="total--deaths">
                  <div>
                    <p>Fatal Cases</p>
                    <h3>{formatNumber(deaths)}
                      <sup className="error">{
                        todayDeaths > 0 ? ` +${formatNumber(todayDeaths)}` : ` -${formatNumber(todayDeaths)}`
                      }</sup>
                    </h3>
                    <p><sub className="error">{deathsPerOneMillion} per million</sub><sub> - </sub><sub className="error">{((deaths / cases) * 100).toFixed(0)}% of confirmed cases</sub></p>
                  </div>
                </div>
                <div className="total--recovered">
                  <div>
                    <p>Recovered Cases</p>
                    <h3>{formatNumber(recovered)}
                      <sup className="rec">{
                        (recovered - prevRecovered) > 0 ? ` +${formatNumber(recovered - prevRecovered)}` : ` -${formatNumber(prevRecovered - recovered)}`
                      }</sup>
                    </h3>
                    <p><sub className="rec">{((recovered / cases) * 100).toFixed(0)}% of confirmed cases</sub></p>
                  </div>
                </div>
                {
                  //   <div className="total--deaths">
                  //   <div>
                  //     <p>Fatal %</p>
                  //     <h3>{((deaths / cases) * 100).toFixed(2)} %</h3>
                  //   </div>
                  // </div>
                  // <div className="total--recovered">
                  //   <div>
                  //     <p>Recovered %</p>
                  //     <h3>{((recovered / cases) * 100).toFixed(2)} %</h3>
                  //   </div>
                  // </div>
                }
              </div>
            </div>
          </div>
        </React.Fragment>);
    }
    return (
      <div className="summary--wrapper">
        {app}
      </div>
    );
  }
}

export default Summary;